import React from 'react';
import { createRoot } from 'react-dom/client';

import { InsuranceForm } from '../main-app/components/InsuranceForm';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-insurance-form');
  if (node) {
    const root = createRoot(node);
    root.render(<InsuranceForm />);
  }
});
